import { onDocumentEvent } from '@app/utils/domHelpers'
import showDropZone from '../../common/show-dropzone'

function removeClosest(event) {
  event.preventDefault()

  const elementToRemove = event.target.closest(
    '[data-behaviour~="export-element"]'
  )

  elementToRemove.remove()

  showDropZone()
}

export default () =>
  onDocumentEvent(
    document,
    'click',
    '[data-behaviour="export-remove-item"]',
    removeClosest
  )
